<div class="compact-popup" *ngIf="viewMode === 'list'">
  <div class="well-list-title">{{wellGroup.length}} wells at this location</div>
  <div class="well-list">
    <button *ngFor="let w of wellGroup"
            type="button"
            class="well-row"
            (click)="selectFromList(w)">
      <span class="well-row-dot" [style.background-color]="w.startIn | statusColor : w.duration"></span>
      <span class="well-row-name">{{w.wellName}}</span>
      <span class="well-row-status">{{getStatusText(w)}}</span>
    </button>
  </div>
</div>

<div class="compact-popup" *ngIf="viewMode === 'detail'">
  <div class="group-nav" *ngIf="wellGroup.length > 1">
    <button type="button" class="back-link" (click)="onBackToList()">
      &larr; All {{wellGroup.length}} wells here
    </button>
    <div class="well-nav-arrows">
      <button type="button" class="nav-arrow" (click)="cycleGroupWell(-1)" aria-label="Previous well">&lsaquo;</button>
      <span class="well-nav-count">{{getGroupIndex() + 1}} / {{wellGroup.length}}</span>
      <button type="button" class="nav-arrow" (click)="cycleGroupWell(1)" aria-label="Next well">&rsaquo;</button>
    </div>
  </div>
  <div class="compact-header">
    <div class="name">{{well?.wellName}}</div>
    <span class="status-badge" [style.background-color]="well?.startIn | statusColor : well?.duration">
      {{getStatusText()}}
    </span>
  </div>
  <div class="compact-fields">
    <div class="compact-field">
      <span class="compact-label">Operator</span>
      <span class="compact-value">{{well?.companyName}}</span>
    </div>
    <div class="compact-field">
      <span class="compact-label">Frac Start</span>
      <span class="compact-value">{{well?.fracStartDate | dateFormatter}}</span>
    </div>
    <div class="compact-field">
      <span class="compact-label">Days to Start</span>
      <span class="compact-value">{{getDaysText()}}</span>
    </div>
  </div>
  <button class="view-details-btn" (click)="onViewDetails()">View Details</button>
</div>
